export const NavigationKeys = {
  TUTORIAL: 'tutorial',
  LOGIN: 'login',
  TABS: 'tabs',
  TABS_HOME: 'tabs/home',
  TABS_BUY: 'buy',
  TABS_EXTRA: 'extra',
  TABS_PROGRAMS: 'programs',
  TABS_BALANCE: 'balance',
  REGISTER_STEP_ONE: 'registration',
  REGISTER_STEP_TWO: 'registration2',
  REGISTER_STEP_THREE: 'registration3',
  REGISTER_CONFIRMATION: 'registrationconfirmation',
  REGISTER_TUROTIAL: 'tutorial',
  RECUPERATION_PASS: 'recuperationpass',
  RECUPERATION_PASS_CONFIRM: 'confirmrecuperationpass',
  WELCOME: 'welcome',
  CHANGE_PASSWORD: 'changepassword',
  SIGNATURIT: 'signaturit',
  DOCUMENT_SIGN: 'accessionbulletin',
  PROGRAM_DETAIL: 'program-detail',
  FAVOURITES_PARTNERS: 'favourites-partners',
  CONTRIBUTION_SHOP: 'contribution-shop',
  QR_SCANNER: 'qr-scanner'
};

export const AuthNavigationKeys = [
  'tabs',
  'changepassword',
  'registrationconfirmation',
  'registration3',
  'home',
  'buy',
  'extra',
  'programs',
  'balance',
  'confirmrecuperationpass',
  'recuperationpass'
];
